export const convertMoney = (amount?: number) => {
  return amount ? amount?.toLocaleString('ru') : 0;
};
